<template>
  <div class="login">
    <div class="login__wrapper">
      <div class="login__title">Register</div>
      <div class="login__form">
        <form class="form" @submit.prevent="onSubmit()">
          <div class="login__row">
            <label class="form__label">Name</label>
            <div class="form__inlet">
              <input type="text" class="form__field" :class="{'border border-danger': $v.name.$error}" v-model.trim="$v.name.$model"/>
            </div>
            <div class="text-danger" v-if="$v.$anyDirty && !$v.name.required">Field is required</div>
          </div>
          <div class="login__row">
            <label class="form__label">Email</label>
            <input type="text" class="form__field" :class="{'border border-danger': $v.email.$error}" v-model.trim="$v.email.$model"/>
            <div class="text-danger" v-if="$v.$anyDirty && !$v.email.required">Field is required</div>
            <div class="text-danger" v-if="$v.$anyDirty && !$v.email.email">Invalid Email</div>
          </div>
          <div class="login__row">
            <label class="form__label">Country</label>
            <vue-select id="userCountry" v-model="country_id" :options="getCountriesOptions()"></vue-select>
            <div class="text-danger" v-if="$v.$anyDirty && !$v.country_id.required">Field is required</div>
          </div>
          <div class="login__row">
            <label class="form__label">Phone Number</label>
            <div class="form__inlet">
              <input type="text" class="form__field form__field-code" v-model="phone_prefix"/>
              <input type="text" class="form__field" v-model="phone"/>
            </div>
            <div class="text-danger" v-if="$v.$anyDirty && !$v.phone.required">Field is required</div>
          </div>
          <div class="form__bent">
            <label class="form__label">Password</label>
            <div class="form__password position-relative">
              <input :type="showPassStatus ? 'text' : 'password'" class="form__field" v-model="password"/>
              <span class="form__eye" :class="{'d-block': password.length}">
                <span :class="showPassStatus ? 'form__hide' : 'form__show'" @click="showPassStatus = !showPassStatus"></span>
              </span>
              <div class="text-danger" v-if="$v.$anyDirty && !$v.password.required">Field is required</div>
            </div>
          </div>
          <div class="form__bent">
            <label class="form__label">Repeat Password</label>
            <div class="form__password position-relative">
              <input :type="showPassStatus ? 'text' : 'password'" class="form__field" v-model="password_confirmation"/>
              <span class="form__eye" :class="{'d-block': password_confirmation.length}">
                <span :class="showPassStatus ? 'form__hide' : 'form__show'" @click="showPassStatus = !showPassStatus"></span>
              </span>
              <div class="text-danger" v-if="$v.$anyDirty && !$v.password_confirmation.required">Field is required</div>
            </div>
          </div>
          <div class="login__knob">
            <button type="submit" class="login__btn">Register</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import {required, minLength, email} from 'vuelidate/lib/validators'
  import {validationMixin} from 'vuelidate'
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: "Register",
    mixins: [validationMixin],
    data() {
      return {
        name: '',
        email: '',
        phone: '',
        password: '',
        password_confirmation: '',
        country_id: '',
        phone_prefix: '',
        showPassStatus: false,
      }
    },
    validations: {
      name: {required},
      phone: {required},
      email: {required, email},
      country_id: {required},
      password: {required, minLength: minLength(4)},
      password_confirmation: {required, minLength: minLength(4)},
    },
    computed: {
      ...mapGetters([
        'getCountriesOptions'
      ])
    },
    watch: {
      phone_prefix(val) {
        if (val.substr(0, 1) != '+')
          this.phone_prefix = '+' + this.phone_prefix
      }
    },
    mounted() {
      this.queryCountries()
    },
    methods: {
      ...mapActions([
        'queryCountries',
        'registerMonitor',
        'setToast'
      ]),
      onSubmit() {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          if (this.password == this.password_confirmation) {
            const user = {
              name: this.name,
              email: this.email,
              country_id: this.country_id,
              phone: this.phone_prefix + ' ' + this.phone,
              password: this.password,
            }
            if (this.registerMonitor(user)) {
              this.name = ''
              this.email = ''
              this.phone = ''
              this.password = ''
              this.password_confirmation = ''
              this.country_id = ''
              this.phone_prefix = ''
              this.showPassStatus = false
            }
          } else {
            this.setToast({message: 'passwords are not the same', status: 'error'})
          }
        }
      },
    }
  }
</script>

<style scoped>

</style>